import { apiGet, apiPost, apiPut } from "./client";

export interface PromptTemplate {
  kind: string;
  name: string;
  description: string;
  systemPrompt?: string;
  outputContract?: string;
  category?: string;
  enabled?: boolean;
  version: number;
  isActive: boolean;
  parsePattern: string;
  maxDuration: number;
  model?: string;
  allowedTools?: string[];
  disallowedTools?: string[];
  requiresCv: boolean;
  requiresProfile: boolean;
  requiresMemory: boolean;
  requiresDedup: boolean;
  requiresContext?: string[];
  changelog?: string;
  createdAt?: string;
  updatedAt?: string;
}

export async function listPrompts(params?: {
  category?: string;
}): Promise<PromptTemplate[]> {
  const res = await apiGet<{ prompts: PromptTemplate[] }>("/api/prompts", params);
  return res.prompts ?? [];
}

export async function getPrompt(kind: string): Promise<PromptTemplate> {
  return apiGet<PromptTemplate>(`/api/prompts/${encodeURIComponent(kind)}`);
}

export async function listPromptVersions(
  kind: string,
): Promise<PromptTemplate[]> {
  const res = await apiGet<{ versions: PromptTemplate[] }>(
    `/api/prompts/${encodeURIComponent(kind)}/versions`,
  );
  return res.versions ?? [];
}

export async function updatePrompt(
  kind: string,
  body: Partial<PromptTemplate> & {
    name: string;
    systemPrompt: string;
  },
): Promise<{ message: string; prompt: PromptTemplate }> {
  return apiPut(`/api/prompts/${encodeURIComponent(kind)}`, body);
}

export async function activatePromptVersion(
  kind: string,
  version: number,
): Promise<{ message: string; prompt?: PromptTemplate }> {
  return apiPost(`/api/prompts/${encodeURIComponent(kind)}/activate`, {
    version,
  });
}

export async function previewPrompt(
  kind: string,
  input: string,
): Promise<{
  kind: string;
  assembled: {
    prompt: string;
    maxDuration: number;
    parsePattern: string;
    model: string;
  };
  unreplacedPlaceholders: string[];
}> {
  return apiPost(`/api/prompts/${encodeURIComponent(kind)}/preview`, { input });
}
